import { ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxGlideComponent } from 'ngx-glide';
import { DepartmentFilter, GetFeaturedTournamentParams, HomeService } from '../../home.service';

interface SituationFilter {
    value: string;
    checked: boolean;
}

@Component({
    selector: 'app-featured-tournaments',
    templateUrl: './featured-tournaments.component.html',
    styleUrls: ['./featured-tournaments.component.scss'],
})
export class FeaturedTournamentsComponent implements OnInit {
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno de dados da API, coleção das recentes notícias
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    /**
     * Tipo de layout que deve ser renderizado
     */
    @Input() type: string;

    /**
     * Referência ao template de layout dos torneios em destaque
     */
    tournamentsTemplate: TemplateRef<any>;
    /**
     * Configuração do slide por breakpoint
     */
    breakpoints = {
        767: {
            perView: 1,
        },
    };

    /**
     * Opções de situação para utilização como filtro
     * quando o tipo de layout for '2' (slide)
     */
    filters: SituationFilter[];

    /**
     * Opções de filtro por deparatmento
     */
    departmentFilters: DepartmentFilter[];
    selectedDepartment: string;

    /**
     * Determina estado de carregamento
     */
    loading: boolean = false;

    /**
     * @Deprecated Template 01
     */
    @ViewChild('tournamentsNewDefault') template01: TemplateRef<any>;
    @ViewChild('tournamentsInline') template02: TemplateRef<any>;
    @ViewChild('tournamentsDepartmentFilter') template03: TemplateRef<any>;

    /**
     * Instancia do ngx glide
     */
    @ViewChild('ngxGlide') ngxGlide!: NgxGlideComponent;

    constructor(
        public homeService: HomeService,
        private cdRef: ChangeDetectorRef,
        public translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.getFeaturedTournaments();
    }

    ngAfterViewInit() {
        this.filters = [
            {
                value: '3',
                checked: false,
            },
            {
                value: '5',
                checked: false,
            },
            {
                value: '9',
                checked: false,
            },
        ];
        this.cdRef.detectChanges();
    }

    onSituationChange(checked, situation, index) {
        if (checked) {
            this.filters.forEach((f) => (f.checked = false));
            this.filters[index].checked = checked;
            this.getFeaturedTournaments({ situacao: situation });
        } else {
            this.getFeaturedTournaments();
        }
    }

    onDepartmentChange(departmentType) {
        this.getFeaturedTournaments({ departmentType });
    }

    getFeaturedTournaments(params: GetFeaturedTournamentParams = {}) {
        this.loading = true;
        if (this.type === '2') {
            params.agrupado = 0;
        } else {
            params.agrupado = 1;
        }

        // FIX: FILTRA APENAS INSCRICOES ABERTAS
        params.situacao = 3;

        this.homeService.getFeaturedTournaments(params).subscribe(
            (response) => this.successCallbackApi(response),
            (error) => this.errorCallbackServer(error),
            () => {
                setTimeout(() => {
                    this.ngxGlide?.recreate();
                }, 0);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers.list;
        this.departmentFilters = response.registers.filter;
        this.selectedDepartment = this.departmentFilters.find(
            (deparmentFilter) => deparmentFilter.selected
        )?.tipo_depto;

        this.loading = false;

    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
        this.loading = false;
    }
}
